import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaEye, FaExternalLinkAlt, FaCalendarAlt, FaTag, FaPaperPlane } from 'react-icons/fa';
import emailjs from '@emailjs/browser';
import styled from 'styled-components';

const ReferencesPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedProject, setSelectedProject] = useState(null);
  const [quickContactData, setQuickContactData] = useState({
    name: '',
    phone: ''
  });

  // Cihaz türünü algılayan fonksiyon
  const getFeastoLink = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // iOS cihaz kontrolü
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "https://apps.apple.com/tr/app/feasto/id6736676749";
    }

    // Android için Play Store
    return "https://play.google.com/store/apps/details?id=com.yusuftahademirer.Feasto&hl=tr";
  };

  const projects = [
    {
      id: 1,
      title: "Amatör Lig Web Sitesi",
      client: "Amatör Futbol Ligleri",
      category: "web-design",
      year: "2015",
      image: "/media/demirer-ajans-7.png",
      description: "Wordpress teması kurulumu ile amatör futbol ligleri için dinamik bir platform",
      link: "https://www.amatorlig.net/"
    },
    {
      id: 2,
      title: "Alibeyköyspor Web Sitesi",
      client: "Alibeyköyspor",
      category: "web-design",
      year: "2017",
      image: "/media/demirer-ajans-8.png",
      description: "Wordpress teması kurulumu ile resmi Alibeyköyspor web sitesi",
      link: "https://alibeykoyspor.com/"
    },
    {
      id: 3,
      title: "Vale Web Sitesi",
      client: "Nişantaşı Vale",
      category: "web-design",
      year: "2025",
      image: "/media/demirer-ajans-1.png",
      description: "Modern ve kullanıcı dostu vale web sitesi tasarımı ve geliştirmesi",
      link: "https://nisantasivale.com.tr"
    },
    {
      id: 4,
      title: "Ergoterapist Web Sitesi",
      client: "Esmanur Balcı",
      category: "web-design",
      year: "2025",
      image: "/media/demirer-ajans-2.png",
      description: "Profesyonel ergoterapist web sitesi tasarımı ve geliştirmesi",
      link: "https://www.esmanurbalci.com.tr/"
    },
    {
      id: 6,
      title: "Kurumsal Mobilya Web Sitesi",
      client: "Balcı Mobilya",
      category: "web-design",
      year: "2025",
      image: "/media/demirer-ajans-9.png",
      description: "Modern ve kullanıcı dostu kurumsal mobilya web sitesi tasarımı ve geliştirmesi",
      link: "https://balcimobilya.com/"
    },
    {
      id: 7,
      title: "Kurumsal İş Makinesi Hizmetleri Web Sitesi",
      client: "Sezer Platform",
      category: "web-design",
      year: "2025",
      image: "/media/demirer-ajans-25.png",
      description: "Modern ve kullanıcı dostu kurumsal iş makinesi hizmetleri web sitesi tasarımı ve geliştirmesi",
      link: "https://sezerplatform.com/"
    },
    {
      id: 8,
      title: "Feasto",
      client: "Yusuf Taha Demirer",
      category: "mobile-app",
      year: "2025",
      image: "/media/demirer-ajans-5.png",
      description: "iOS ve Android uyumlu modern ve kullanıcı dostu mobil uygulama geliştirmesi",
      link: getFeastoLink()
    },
    {
      id: 9,
      title: "Alibeyköyspor Instagram Hesabı Yönetimi",
      client: "Alibeyköyspor",
      category: "social-media",
      year: "2010 - 2020",
      image: "/media/demirer-ajans-15.png",
      description: "Kapsamlı sosyal medya yönetimi ve içerik üretimi",
      link: "https://www.instagram.com/alibeykoysk/"
    },
    {
      id: 10,
      title: "Bayburt 1918 FK Instagram Hesabı Yönetimi",
      client: "Bayburt 1918 FK",
      category: "social-media",
      year: "2021 - 2022",
      image: "/media/demirer-ajans-19.png",
      description: "Kapsamlı sosyal medya yönetimi ve içerik üretimi",
      link: "https://www.instagram.com/bayburtfk1918/"
    },
    {
      id: 11,
      title: "Balcı Mobilya Instagram Hesabı Yönetimi",
      client: "Balcı Mobilya",
      category: "social-media",
      year: "2021",
      image: "/media/demirer-ajans-16.png",
      description: "Kapsamlı sosyal medya yönetimi ve içerik üretimi",
      link: "https://www.instagram.com/balcimobilyamm/"
    },
    {
      id: 12,
      title: "Yataş Bedding Instagram Hesabı Yönetimi",
      client: "Yataş Bedding",
      category: "social-media",
      year: "2023",
      image: "/media/demirer-ajans-3.png",
      description: "Kapsamlı sosyal medya yönetimi ve içerik üretimi",
      link: "https://www.instagram.com/yatasbeddingalibeykoy/"
    },
    {
      id: 13,
      title: "Amatör Lig Web Sitesi SEO Optimizasyonu",
      client: "Amatör Futbol Ligleri",
      category: "seo",
      year: "2015",
      image: "/media/demirer-ajans-16.png",
      description: "SEO optimizasyonu ile web sitesinin arama motorlarındaki görünürlüğünü artırma",
      link: "https://www.amatorlig.net/"
    },
    {
      id: 14,
      title: "Alibeyköyspor Web Sitesi SEO Optimizasyonu",
      client: "Alibeyköyspor",
      category: "seo",
      year: "2020",
      image: "/media/demirer-ajans-7.png",
      description: "SEO optimizasyonu ile web sitesinin arama motorlarındaki görünürlüğünü artırma",
      link: "https://alibeykoyspor.com/"
    },
    {
      id: 15,
      title: "Vale Web Sitesi SEO Optimizasyonu",
      client: "Nişantaşı Vale",
      category: "seo",
      year: "2025",
      image: "/media/demirer-ajans-8.png",
      description: "SEO optimizasyonu ile web sitesinin arama motorlarındaki görünürlüğünü artırma",
      link: "https://nisantasivale.com.tr"
    },
    {
      id: 16,
      title: "Ergoterapist Web Sitesi SEO Optimizasyonu",
      client: "Esmanur Balcı",
      category: "seo",
      year: "2025",
      image: "/media/demirer-ajans-4.png",
      description: "SEO optimizasyonu ile web sitesinin arama motorlarındaki görünürlüğünü artırma",
      link: "https://www.esmanurbalci.com.tr/"
    },
    {
      id: 18,
      title: "Kurumsal Mobilya Web Sitesi SEO Optimizasyonu",
      client: "Balcı Mobilya",
      category: "seo",
      year: "2025",
      image: "/media/demirer-ajans-18.png",
      description: "SEO optimizasyonu ile web sitesinin arama motorlarındaki görünürlüğünü artırma",
      link: "https://balcimobilya.com/"
    },
    {
      id: 19,
      title: "Alibeyköyspor Kulüp Fotoğrafçılığı",
      client: "Alibeyköyspor",
      category: "photography",
      year: "2005 - 2020",
      image: "/media/demirer-ajans-19.png",
      description: "Profesyonel fotoğraf ve video çekimi",
      link: "https://www.facebook.com/selimdemirer/photos_albums"
    },
    {
      id: 20,
      title: "Fatih Karagümrük Kulüp Fotoğrafçılığı",
      client: "Fatih Karagümrük",
      category: "photography",
      year: "2017 - 2019",
      image: "/media/demirer-ajans-20.png",
      description: "Profesyonel fotoğraf ve video çekimi",
      link: "https://www.facebook.com/selimdemirer/photos_albums"
    },
    {
      id: 21,
      title: "Bayburt 1918 FK Kulüp Fotoğrafçılığı",
      client: "Bayburt 1918 FK",
      category: "photography",
      year: "2021 - 2022",
      image: "/media/demirer-ajans-21.png",
      description: "Profesyonel fotoğraf ve video çekimi",
      link: "https://www.facebook.com/selimdemirer/photos_albums"
    },

    {
      id: 22,
      title: "Esenler Erokspor Kulüp Fotoğrafçılığı",
      client: "Esenler Erokspor",
      category: "photography",
      year: "2022 - 2024",
      image: "/media/demirer-ajans-22.png",
      description: "Profesyonel fotoğraf ve video çekimi",
      link: "https://www.facebook.com/selimdemirer/photos_albums"
    },
    {
      id: 23,
      title: "Yeşilılgazspor Kulüp Fotoğrafçılığı",
      client: "Yeşilılgazspor",
      category: "photography",
      year: "2024 - 2025",
      image: "/media/demirer-ajans-23.png",
      description: "Profesyonel fotoğraf ve video çekimi",
      link: "https://www.facebook.com/selimdemirer/photos_albums"
    },
    {
      id: 24,
      title: "Talebe Göre Kulüp Fotoğrafçılığı",
      client: "Genel",
      category: "photography",
      year: "2005 - 2025",
      image: "/media/demirer-ajans-24.png",
      description: "Profesyonel fotoğraf ve video çekimi",
      link: "https://www.facebook.com/selimdemirer/photos_albums"
    },
    {
      id: 25,
      title: "Yataş Bedding Instagram Reklam Yönetimi",
      client: "Yataş Bedding",
      category: "advertising",
      year: "2021",
      image: "/media/demirer-ajans-3.png",
      description: "Kapsamlı sosyal medya yönetimi ve içerik üretimi",
      link: "https://www.instagram.com/yatasbeddingalibeykoy/"
    },
    {
      id: 26,
      title: "Balcı Mobilya Instagram Reklam Yönetimi",
      client: "Balcı Mobilya",
      category: "advertising",
      year: "2022",
      image: "/media/demirer-ajans-7.png",
      description: "Kapsamlı sosyal medya yönetimi ve içerik üretimi",
      link: "https://www.instagram.com/balcimobilyamm/"
    },

  ];

  const categories = [
    { value: 'all', label: 'Tümü' },
    { value: 'web-design', label: 'Web Tasarım' },
    { value: 'mobile-app', label: 'Mobil Uygulama' },
    { value: 'social-media', label: 'Sosyal Medya' },
    { value: 'seo', label: 'SEO' },
    { value: 'photography', label: 'Fotoğrafçılık' },
    { value: 'advertising', label: 'Reklam Yönetimi' }
  ];

  const filteredProjects = selectedCategory === 'all'
    ? projects
    : projects.filter(project => project.category === selectedCategory);

  const openModal = (project) => {
    setSelectedProject(project);
  };

  const closeModal = () => {
    setSelectedProject(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === 'phone') {
      const numbersOnly = value.replace(/[^\d]/g, '');
      if (numbersOnly.length <= 11) {
        setQuickContactData({
          ...quickContactData,
          [name]: numbersOnly
        });
      }
    } else {
      setQuickContactData({
        ...quickContactData,
        [name]: value
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (quickContactData.phone.length !== 11) {
      alert('Telefon numarası 11 haneli olmalıdır.');
      return;
    }

    try {
      const templateParams = {
        name: quickContactData.name,
        phone: quickContactData.phone,
        time: new Date().toLocaleString('tr-TR')
      };

      await emailjs.send(
        'service_771tgg7',
        'template_w676du8',
        templateParams,
        'xjG6_a9zdp6ZU1zHp'
      );

      alert('Başarılı');
      setQuickContactData({ name: '', phone: '' });
    } catch (error) {
      alert('Bir hata oluştu');
    }
  };

  return (
    <PageContainer>
      <HeroSection>
        <HeroContent
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <HeroTitle>Referanslarımız</HeroTitle>
          <HeroSubtitle>
            Müşterilerimiz için gerçekleştirdiğimiz başarılı projeler ve dijital çözümler
          </HeroSubtitle>
        </HeroContent>
      </HeroSection>

      <MainContent>
        <Container>
          <FilterSection>
            <FilterTitle>Proje Kategorileri</FilterTitle>
            <FilterGrid>
              {categories.map((category) => (
                <FilterButton
                  key={category.value}
                  active={selectedCategory === category.value}
                  onClick={() => setSelectedCategory(category.value)}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  {category.label}
                </FilterButton>
              ))}
            </FilterGrid>
          </FilterSection>

          <ProjectsGrid>
            {filteredProjects.map((project, index) => (
              <ProjectCard
                key={project.id}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                whileHover={{ y: -10 }}
              >
                <ProjectImage>
                  <img src={project.image} alt={project.title} />
                  <ProjectOverlay>
                    <OverlayButton
                      as="a"
                      href={project.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <FaExternalLinkAlt />
                      <span>Projeye Git</span>
                    </OverlayButton>
                  </ProjectOverlay>
                </ProjectImage>
                <ProjectContent onClick={() => openModal(project)}>
                  <ProjectMeta>
                    <MetaItem>
                      <FaCalendarAlt />
                      <span>{project.year}</span>
                    </MetaItem>
                    <MetaItem>
                      <FaTag />
                      <span>{categories.find(cat => cat.value === project.category)?.label}</span>
                    </MetaItem>
                  </ProjectMeta>
                  <ProjectTitle>{project.title}</ProjectTitle>
                  <ProjectClient>{project.client}</ProjectClient>
                  <ProjectDescription>{project.description}</ProjectDescription>
                </ProjectContent>
              </ProjectCard>
            ))}
          </ProjectsGrid>
        </Container>
      </MainContent>

      <ContactSection>
        <ContactContent>
          <ContactTitle>Sizi Arayalım</ContactTitle>
          <ContactForm onSubmit={handleSubmit}>
            <ContactInput
              type="text"
              name="name"
              placeholder="Adınız"
              value={quickContactData.name}
              onChange={handleInputChange}
              required
            />
            <ContactInput
              type="tel"
              name="phone"
              placeholder="Telefon Numaranız (11 Haneli)"
              value={quickContactData.phone}
              onChange={handleInputChange}
              pattern="[0-9]*"
              inputMode="numeric"
              maxLength="11"
              minLength="11"
              required
            />
            <SubmitButton
              type="submit"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaPaperPlane />
            </SubmitButton>
          </ContactForm>
        </ContactContent>
      </ContactSection>

      {/* Modal */}
      {selectedProject && (
        <Modal
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={closeModal}
        >
          <ModalContent
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
          >
            <ModalClose onClick={closeModal}>&times;</ModalClose>
            <ModalImage>
              <img src={selectedProject.image} alt={selectedProject.title} />
            </ModalImage>
            <ModalInfo>
              <ModalTitle>{selectedProject.title}</ModalTitle>
              <ModalClient>{selectedProject.client}</ModalClient>
              <ModalDescription>{selectedProject.description}</ModalDescription>
              <TechStack>
                <TechTitle>Kullanılan Teknolojiler:</TechTitle>
                <TechList>
                  {selectedProject.technologies?.map((tech, index) => (
                    <TechItem key={index}>{tech}</TechItem>
                  ))}
                </TechList>
              </TechStack>
              <ModalActions>
                <ActionButton href={selectedProject.link} target="_blank" rel="noopener noreferrer">
                  <FaExternalLinkAlt />
                  <span>Projeyi Görüntüle</span>
                </ActionButton>
              </ModalActions>
            </ModalInfo>
          </ModalContent>
        </Modal>
      )}

    </PageContainer>
  );
};

// Styled Components
const PageContainer = styled.div`
  padding: 8rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const HeroSection = styled.section`
  margin-bottom: 4rem;
  text-align: center;
`;

const HeroContent = styled(motion.div)`
  max-width: 800px;
  margin: 0 auto;
`;

const HeroTitle = styled.h1`
  font-size: 3.5rem;
  color: #1f2937;
  margin-bottom: 1rem;
  background: linear-gradient(45deg, #00B4DB, #007bff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    font-size: 3rem;
  }
`;

const HeroSubtitle = styled.p`
  font-size: 1.4rem;
  color: #4b5563;
  line-height: 1.6;
  max-width: 800px;
  margin: 0 auto;

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }
`;

const MainContent = styled.section`
  margin-bottom: 4rem;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const FilterSection = styled.div`
  margin-bottom: 4rem;
  text-align: center;
`;

const FilterTitle = styled.h2`
  color: #1f2937;
  font-size: 2rem;
  margin-bottom: 2rem;
  font-weight: 600;
`;

const FilterGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
`;

const FilterButton = styled(motion.button)`
  background: ${props => props.active ? 'linear-gradient(45deg, #00B4DB, #007bff)' : 'white'};
  border: 2px solid ${props => props.active ? 'transparent' : '#e5e7eb'};
  color: ${props => props.active ? 'white' : '#4b5563'};
  padding: 0.75rem 1.5rem;
  border-radius: 25px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  &:hover {
    background: ${props => props.active ? 'linear-gradient(45deg, #0099cc, #0066ff)' : '#f9fafb'};
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  }
`;

const ProjectsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

const ProjectCard = styled(motion.div)`
  background: white;
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  }
`;

const ProjectImage = styled.div`
  position: relative;
  height: 200px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }

  &:hover img {
    transform: scale(1.05);
  }
`;

const ProjectOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(0, 180, 219, 0.9), rgba(0, 123, 255, 0.9));
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;

  ${ProjectCard}:hover & {
    opacity: 1;
  }
`;

const OverlayButton = styled.div`
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  color: white;
  padding: 1rem 2rem;
  border-radius: 30px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
  border: 1px solid rgba(255, 255, 255, 0.3);
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.05);
  }
`;

const ProjectContent = styled.div`
  padding: 1.5rem;
  cursor: pointer;
  
  &:hover {
    background: #f9fafb;
  }
`;

const ProjectMeta = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
`;

const MetaItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #6b7280;
  font-size: 0.9rem;

  svg {
    font-size: 0.8rem;
    color: #00B4DB;
  }
`;

const ProjectTitle = styled.h3`
  color: #1f2937;
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
`;

const ProjectClient = styled.p`
  color: #4b5563;
  font-size: 0.95rem;
  margin-bottom: 1rem;
  font-weight: 500;
`;

const ProjectDescription = styled.p`
  color: #6b7280;
  line-height: 1.6;
  font-size: 0.9rem;
`;

// Modal Styles
const Modal = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 2rem;
`;

const ModalContent = styled(motion.div)`
  background: white;
  border-radius: 20px;
  max-width: 800px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
`;

const ModalClose = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 1.5rem;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(0, 0, 0, 0.7);
  }
`;

const ModalImage = styled.div`
  height: 300px;
  overflow: hidden;
  border-radius: 20px 20px 0 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const ModalInfo = styled.div`
  padding: 2rem;
`;

const ModalTitle = styled.h2`
  color: #1f2937;
  font-size: 1.75rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
`;

const ModalClient = styled.p`
  color: #6b7280;
  font-size: 1.1rem;
  margin-bottom: 1.5rem;
  font-weight: 500;
`;

const ModalDescription = styled.p`
  color: #4b5563;
  line-height: 1.7;
  margin-bottom: 2rem;
  font-size: 1rem;
`;

const TechStack = styled.div`
  margin-bottom: 2rem;
`;

const TechTitle = styled.h4`
  color: #1f2937;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 1rem;
`;

const TechList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

const TechItem = styled.span`
  background: linear-gradient(45deg, #00B4DB, #007bff);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
`;

const ModalActions = styled.div`
  display: flex;
  gap: 1rem;
`;

// Contact Section Styles
const ContactSection = styled.section`
  padding: 4rem 2rem;
  background: linear-gradient(45deg, #00B4DB, #007bff);
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 250px;
  color: white;
  position: relative;
  overflow: hidden;
  margin-top: 4rem;
  border-radius: 20px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 30%;
    height: 100%;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.15), transparent);
    transform: skewX(-20deg) translateX(30%);
    transform-origin: top right;
    pointer-events: none;
    z-index: 0;
  }
`;

const ContactContent = styled.div`
  position: relative;
  z-index: 1;
  max-width: 600px;
  width: 100%;
`;

const ContactTitle = styled.h2`
  font-size: 2.5rem;
  color: white;
  margin-bottom: 2rem;
`;

const ContactForm = styled.form`
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;

const ContactInput = styled.input`
  padding: 1rem 1.5rem;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  flex: 1;
  min-width: 200px;
  background: rgba(255, 255, 255, 0.9);
  color: #1f2937;

  &::placeholder {
    color: #6b7280;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
  }
`;

const SubmitButton = styled(motion.button)`
  background: #00B4DB;
  color: white;
  border: none;
  padding: 1rem 1.5rem;
  font-size: 1.2rem;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 180, 219, 0.2);

  &:hover {
    background: #007bff;
    transform: scale(1.02);
    box-shadow: 0 4px 12px rgba(0, 180, 219, 0.3);
  }

  svg {
    margin: 0;
  }
`;

const ActionButton = styled.a`
  background: linear-gradient(45deg, #00B4DB, #007bff);
  color: white;
  padding: 1rem 2rem;
  border-radius: 30px;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 180, 219, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 180, 219, 0.4);
  }
`;

export default ReferencesPage;
